module.exports = __webpack_public_path__ + "img/logo21.06f00766.png";